module.exports = __webpack_public_path__ + "img/Consensus.426201a.jpg";